import { gql } from '@apollo/client'
import { PICOS_PRIORITY_FRAGMENT } from '../fragments'

export const GET_PICOS_PRIORITIES_TO_UPDATE = gql`
  query GetPicosPrioritiesToUpdate($input: NullablePicOSPriorityInput!) {
    picosPrioritiesToUpdate(input: $input) {
      count
      hasMore
      results {
        ...PicOSPriority
      }
    }
  }
  ${PICOS_PRIORITY_FRAGMENT}
`
